<template xmlns="http://www.w3.org/1999/html">
  <div class="bg">
    <div class="container">
      <el-row>
        <el-row :gutter="15">
          <el-col :span="16">
            <el-card shadow="never" class="box-card">
              <div>
                <el-row :gutter="15">
                  <el-col class="comtab" :span="24">
                    <div class="tab">
                      <div @click="officeProduct" :class="officeTab ? 'left_product_choose' : 'left_product'"
                        style="margin-right:20px">{{ '办公应用' }}</div>
                      <div @click="allProduct" :class="productTab ? 'left_product_choose' : 'left_product'">{{ isall ?
                        "全部产品" : "我的产品" }}</div>
                    </div>
                    <div class="right" @click="changeProductType()" v-if="productTab">
                      {{ isall ? "我的产品" : "全部产品" }}
                    </div>
                    <div class="right" v-if="officeTab">
                      <el-input size="small" style="width: 100%" @input="keywordChange($event)"
                        suffix-icon="el-icon-search" placeholder="搜索" v-model="officeQueryParams.officeName">
                      </el-input>
                    </div>
                  </el-col>
                  <el-col :span="24" v-if="productTab">
                    <el-empty v-if="!productList.length" :image="require('../../static/img/display-img/noData.png')"
                      description="暂无产品"></el-empty>
                  </el-col>
                  <el-col class="comcol" :span="6" v-for="(item, index) in productList" :key="index" v-if="productTab">
                    <el-button class="combutton" plain @click="handleItemClick(item)">
                      <div>
                        <span>
                          {{ item.sysName }}
                        </span>
                      </div>
                      <div class="lastuse">
                        <span style="overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;">{{ item.desc }}</span>
                      </div>
                    </el-button>
                  </el-col>
                  <el-col :span="24" v-if="officeTab">
                    <el-empty v-if="!officetList.length" :image="require('../../static/img/display-img/noData.png')"
                      description="暂无产品"></el-empty>
                  </el-col>
                  <el-col class="comcol" :span="6" v-for="(item, index) in officetList" :key="index" v-if="officeTab">
                    <el-button class="combutton_office" plain @click="officeItemClick(item)">
                      <div class="com_office">
                        <div class="com_office_img">
                          <img :src="item.img" alt="">
                        </div>
                        <div class="com_office_name">
                          <p class="text">{{ item.name }}</p>
                        </div>
                      </div>
                    </el-button>
                  </el-col>
                </el-row>
              </div>
              <div style="text-align: center;margin-top:20px" v-if="officeTab">
                <el-pagination background hide-on-single-page :page-size.sync="officeQueryParams.pageSize"
                  :current-page.sync="officeQueryParams.pageNum" layout="prev, pager, next" :total="officeTotal"
                  @current-change="handleOfficeChange">
                </el-pagination>
              </div>

            </el-card>
            <el-card shadow="never" class="box-card">
              <div>
                <el-row :gutter="15">
                  <el-col class="comtab" :span="24">
                    <div class="left">
                      最近使用产品
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <el-empty v-if="!resentProductList.length" :image="require('../../static/img/display-img/noData.png')"
                      description="暂无产品"></el-empty>
                  </el-col>
                  <el-col class="comcol" :span="6" v-for="(item, index) in resentProductList" :key="index">
                    <el-button class="combutton" plain @click="handleItemClick(item)">
                      <div>
                        <span>
                          {{ item.sysName }}
                        </span>
                      </div>
                      <div class="lastuse">
                        <span>上次打开{{ item.createTime }}</span>
                      </div>
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card shadow="never" class="box-card">
              <div>
                <el-row :gutter="15">
                  <el-col class="comtab" :span="24">
                    <div class="left">
                      平台资讯
                    </div>
                  </el-col>
                  <el-col class="comcol" :span="24">
                    <ul>
                      <li v-for="(item, index) in rows" :key="index">
                        <div class="date">
                          <div class="number">
                            <p class="day">
                              {{ item.day }}
                            </p>
                            <p class="mon">
                              {{ item.month }}月
                            </p>
                          </div>
                        </div>
                        <!-- <el-link class="content" style="font-size: 14px;" @click="openArticle(item)">
                          {{ item.title }}
                        </el-link> -->
                        <p class="content" @click="openArticle(item)">
                          {{ item.title }}
                        </p>
                      </li>
                    </ul>
                  </el-col>
                </el-row>
              </div>
              <div style="text-align: center">
                <el-pagination background hide-on-single-page :page-size.sync="queryParams.pageSize"
                  :current-page.sync="queryParams.pageNum" layout="prev, pager, next" :total="total"
                  @current-change="handleCurrentChange">
                </el-pagination>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card shadow="never" class="box-card header-card">
              <div class="header">
                <div class="icon">
                  <img style="width: 58px; height: 58px;" src="../assets/images/console/userimg.png" alt="">
                </div>
                <div class="info">
                  <p class="name">{{ $store.state.user.userName }}</p>
                  <!-- <p class="company"> {{ userName }} </p> -->
                  <div class="addCompany" v-if="companyType == 3">
                    <p>未加入企业</p>
                    <div @click="openComClick">点击申请</div>
                  </div>
                  <div class="addCompany" v-if="companyType == 2">
                    <p>加入企业申请审核中</p>
                  </div>
                  <div class="addCompany" v-if="companyType == 1">
                    <p>{{ companyUserName }}</p>
                  </div>
                  <div class="addCompany" v-if="companyType == 0">
                    <p>加入企业申请未通过</p>
                    <div @click="openReason = true">查看未通过原因</div>
                  </div>
                </div>
              </div>
              <el-row :gutter="15">
                <el-col :span="22" :offset="1">
                  <div class="team">
                    <div class="teambox">
                      <div class="yingyong">
                        <img src="../assets/images/console/yingyong.png" alt="">
                        <p class="team-title">
                          我的产品
                        </p>
                        <p class="number">
                          <span style="font-size: 18px;font-weight: bold;">
                            {{ myproductnum || 0 }}
                          </span>
                          款
                        </p>
                      </div>
                      <div class="tuandui">
                        <img src="../assets/images/console/tuandui.png" alt="">
                        <p class="team-title">
                          团队人数
                        </p>
                        <p class="number">
                          <span style="font-size: 18px;font-weight: bold;">
                            {{ myteammenbernum || 1 }}
                          </span>
                          人
                        </p>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>

            </el-card>
            <el-card shadow="never" class="box-card">
              <a-calendar :fullscreen="false" @panelChange="onPanelChange" @select="selectData">
                <template #headerRender="{ value, type, onChange, onTypeChange }">
                  <div style="padding: 10px">
                    <a-row type="flex" justify="center">
                      <a-col>
                        <a-select size="small" :dropdown-match-select-width="false" class="my-year-select"
                          :value="String(value.year())" @change="newYear => {
                            onChange(value.clone().year(newYear));
                          }">
                          <a-select-option v-for="val in getYears(value)" :key="String(val)" class="year-item">
                            {{ val }}
                          </a-select-option>
                        </a-select>
                      </a-col>
                      <a-col>
                        <a-select size="small" :dropdown-match-select-width="false" :value="String(value.month())"
                          @change="selectedMonth => {
                            onChange(value.clone().month(parseInt(selectedMonth, 10)));
                          }">
                          <a-select-option v-for="(val, index) in getMonths(value)" :key="String(index)"
                            class="month-item">
                            {{ val }}
                          </a-select-option>
                        </a-select>
                      </a-col>
                    </a-row>
                  </div>
                </template>
              </a-calendar>
              <a-divider />
              <div style="min-height: 140px">
                <el-empty v-if="scheduleRows === null || scheduleRows.length === 0"
                  :image="require('../../static/img/display-img/noData.png')" :image-size="80"
                  description="暂无日程"></el-empty>
                <ul class="richeng">
                  <li v-for="(item, index) in scheduleRows" :key=index>
                    <el-row :gutter="1">
                      <el-col :span="6">
                        <span
                          style="color: #999;font-size: 12px;font-style: normal;font-weight: 500;line-height: normal;">{{
                            item.intervalTime }}</span>
                      </el-col>
                      <el-col :span="14">
                        <span
                          style="display: inline-block;width: 150px;height: 27px;line-height: 27px;;overflow: hidden;color: var(--666, #666);text-overflow: ellipsis;whitespace: nowrap;font-size: 14px;font-style: normal;font-weight: 500;">
                          {{ item.title }}
                        </span>
                      </el-col>
                      <el-col :span="4">
                        <span class="right" @click="cancelSchedule(item)">
                          取消日程
                        </span>
                      </el-col>
                    </el-row>
                  </li>
                </ul>
                <div>
                  <el-row type="flex" :gutter="15" justify="end">
                    <el-col :span="5" style="text-align: right;">
                      <img style="width: 42px; height: 42px; cursor: pointer;" src="../assets/images/console/add.png"
                        alt="" @click="openScheduleFrom('ruleForm')"></el-col>
                  </el-row>
                </div>
                <div>
                  <el-pagination background hide-on-single-page :page-size.sync="scheduleParams.pageSize"
                    :current-page.sync="scheduleParams.pageNum" layout="prev, pager, next" :total="scheduleTotal"
                    @current-change="getScheduleData">
                  </el-pagination>
                </div>
              </div>
            </el-card>
            <el-card style="min-height: 200px" shadow="never" class="box-card">
              <el-col class="newstab" :span="24">
                <div class="left tab">
                  <div :class="isactive == 1 ? 'active' : ''" @click="changeNtab(1)">
                    通知公告
                  </div>
                  <div :class="isactive == 2 ? 'active' : ''" @click="changeNtab(2)">
                    制度规范
                  </div>
                  <div :class="isactive == 3 ? 'active' : ''" @click="changeNtab(3)">
                    行业政策
                  </div>
                </div>
              </el-col>
              <el-col :span="24">
                <el-empty v-if="articleRows === null || articleRows.length === 0"
                  :image="require('../../static/img/display-img/noData.png')" :image-size="80"
                  description="暂无数据"></el-empty>
              </el-col>
              <ul style="margin-top: 50px;">
                <li v-for="(item, index) in articleRows" :key="index" style="margin-top: 20px; vertical-align: middle;"
                  @click="openArticle(item)">
                  <el-row :gutter="15">
                    <el-col :span="16">
                      <p
                        style="margin: 0 ; line-height: 18px;; padding: 0; line-height: 27px; font-size: 14px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor: pointer;">
                        {{ item.title }}</p>
                    </el-col>
                    <el-col :span="8">
                      <span
                        style="display: inline-block;font-size: 12px; line-height: 27px;; color: #999; width: 115px;">{{
                          item.createTime }}</span>
                    </el-col>
                  </el-row>
                </li>
              </ul>
              <div>
                <el-pagination background hide-on-single-page :page-size.sync="coArticleParams.pageSize"
                  :current-page.sync="coArticleParams.pageNum" layout="prev, pager, next" :total="coArticleTotal"
                  @current-change="currentArticleChange">
                </el-pagination>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-row>
      <div class="cloud">
        <img src="@/assets/images/cloud.png" alt="">
      </div>
    </div>
    <el-dialog title="加入企业申请" width="30%" :visible.sync="openCompany" >
      <el-form :model="companyForm" :rules="companyRules" ref="ruleCompanyForm">
        <el-form-item label="姓名：" prop="userName" label-width="180px">
          <el-input style="width: 80%" v-model="companyForm.userName" disabled></el-input>
        </el-form-item>
        <el-form-item label="企业统一社会信用代码：" prop="companyCode" label-width="180px">
          <el-input style="width: 80%" placeholder="请输入申请加入的企业统一社会信用代码" v-model="companyForm.companyCode"></el-input>
        </el-form-item>
        <el-form-item label="企业名称：" prop="companyName" label-width="180px">
          <el-input style="width: 80%" placeholder="请输入申请加入的企业名称" v-model="companyForm.companyName"
            autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="申请理由：" label-width="180px" prop="applyReason">
          <el-input type="textarea" :rows="3" placeholder="请输入" style="width: 80%" v-model="companyForm.applyReason"
            autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="openCompany = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitCompanyInfo('ruleCompanyForm')" size="small">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看未通过原因" width="30%" :visible.sync="openReason" >
      <el-form :model="rejectForm" ref="ruleCompanyForm">
        <el-form-item label="姓名：" prop="userName" label-width="180px">
          <p class="ctbox">{{ rejectForm.userName }}</p>
          <!-- <el-input style="width: 80%" v-model="rejectForm.userName"  disabled></el-input> -->
        </el-form-item>
        <el-form-item label="企业名称：" prop="companyName" label-width="180px">
          <p class="ctbox">{{ rejectForm.companyName }}</p>
          <!-- <el-input style="width: 80%" v-model="rejectForm.companyName" autocomplete="off" disabled></el-input> -->
        </el-form-item>
        <el-form-item label="未通过理由：" label-width="180px" prop="applyReason">
          <!-- <el-input type="textarea" :rows="3" disabled style="width: 80%" v-model="rejectForm.applyReason"
            autocomplete="off"></el-input> -->
          <p class="ctbox">{{ rejectForm.rejectReason }}</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="openReason = false" class="footerbt" size="small">确认</el-button>
        <el-button type="primary" @click="complyAgain" size="small">重新申请</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新增日程" width="30%" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
          <el-input style="width: 80%" placeholder="请输入标题" v-model="form.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime" :label-width="formLabelWidth">
          <el-date-picker style="width: 80%" v-model="form.startTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
            placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime" :label-width="formLabelWidth">
          <el-date-picker style="width: 80%" v-model="form.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
            placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="地点" prop="region" :label-width="formLabelWidth">
          <el-input style="width: 80%" placeholder="请输入地点" v-model="form.region" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="内容" :label-width="formLabelWidth" prop="content">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" style="width: 80%" v-model="form.content"
            autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSchedule('ruleForm')">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="rixingyishan" width="13%">
      <div class="erweima"><img src="@/assets/images/erweima.jpg" alt=""></div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserInfo, getRecord, addRecord, listProduct, articleList, getOfficeList,
  saveOrUpdate, fingList, getApprovalType, getApprovalMess
} from '@/api/console'
import { getConsultList, listSchedule, addSchedule } from '@/api/consult'
import moment from 'moment';
import 'moment/dist/locale/zh-cn';
import { delScheduleById } from "../api/consult";

var dayjs = require('dayjs');
var isSameOrBefore = require('dayjs/plugin/isSameOrBefore');
dayjs.extend(isSameOrBefore);

export default {
  name: 'Console',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value == "") {
        callback('请选择开始时间')
      } else if (dayjs(value).isAfter(dayjs(this.form.endTime))) {
        callback('开始时间必须早于结束时间')
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value == "") {
        callback('请选择结束时间')
      } else if (dayjs(value).isBefore(dayjs(this.form.startTime))) {
        callback('开始时间必须早于结束时间')
      } else {
        callback();
      }
    };
    return {
      userId: '',
      userName: '',
      formLabelWidth: '120px',
      form: {
        title: '',
        content: '',
        region: '',
        startTime: '',
        endTime: '',
        location: '',
        remind: 'NO_REMIND',
      },
      companyForm: {
        userName: "",
        companyCode: '',
        companyName: "",
        applyReason: ""
      },
      rejectForm: {},
      myproductnum: '',
      myteammenbernum: '',
      dialogFormVisible: false,
      locale: moment.locale('zh-cn'),
      type: false,
      productList: [],
      list: [],
      rows: [],
      articleRows: [],
      records: [],
      activeName: 'first',
      isactive: 1,
      isall: false,
      resentProductList: [],
      scheduleRows: [],
      queryParams: {
        articleType: 'PT_CONSULT',
        pageNum: 1,
        pageSize: 5
      },
      officeQueryParams: {
        pageNum: 1,
        pageSize: 12,
        officeName: ""
      },
      coArticleTotal: undefined,
      coArticleParams: {
        articleType: 'CO_NOTICE',
        pageNum: 1,
        pageSize: 5,
        useFlag: 1,
      },
      scheduleTotal: undefined,
      scheduleParams: {
        pageNum: 1,
        pageSize: 5,
        localDate: undefined,
        scheduleStatus: "a"
      },
      rules: {
        title: [
          { required: true, message: '请输入日程标题', trigger: 'blur' },
        ],
        startTime: [
          // { required: true, message: '请选择开始时间', trigger: 'blur' },
          { required: true, validator: validatePass, trigger: 'blur' },
        ],
        endTime: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
        region: [
          { required: true, message: '请输入日程地点', trigger: 'blur' },
        ],
      },
      companyRules: {
        companyCode: [
          { required: true, pattern: /^([0-9A-HJ-NP-RT-UW-Y]){2}([0-9]){6}([0-9A-HJ-NP-RT-UW-Y]{10})$/, message: "请输入正确的社会信用代码", trigger: "blur" }
        ],
        applyReason: [
          { required: true, message: "请输入申请理由", trigger: "blur" }
        ]
      },
      total: undefined,
      productTab: false,
      officeTab: true,
      officetList: [],
      officeTotal: undefined,
      officeName: "",
      openCompany: false,
      openReason: false,
      rixingyishan: false,
      companyType: 4,
      companyUserName: "青岛国真智慧科技有限公司",
      comUserName: ""
    }
  },
  mounted() {
    this.getList()
    this.getOfficeList()
    this.getApprovalMess()
  },
  methods: {
    keywordChange(keywords) {
      this.officeQueryParams.officeName = keywords
      this.getOfficeList()
    },
    // tab
    allProduct() {
      this.getList();
      this.officeTab = false
      // this.changeProductType();
      this.productTab = true
    },
    officeProduct() {
      this.officeTab = true
      this.productTab = false
    },
    openComClick() {
      this.companyForm = {}
      this.companyForm.userName = this.userName;
      console.log(this, 'this');


      this.openCompany = true
    },
    submitSchedule(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          addSchedule(this.form).then(res => {
            if (res.code === 0) {
              this.$message.success("提交成功");
              this.dialogFormVisible = false;
              this.getScheduleData();
            } else {
              this.$message.error("提交失败");
            }
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    complyAgain() {
      this.openReason = false
      this.openCompany = true
    },
    // 提交企业申请
    submitCompanyInfo(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {

          saveOrUpdate(this.companyForm).then(res => {
            if (res.code === 0) {
              this.$message.success("提交成功");
              this.companyType = 2;
              this.openCompany = false;
              // this.getScheduleData();
            } else {
              this.$message.error("提交失败");
              this.openCompany = false;
            }
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 查看企业申请状态

    getApprovalMess() {
      getApprovalMess().then(res => {
        if (res.data) {
          const { userName, companyCode, companyName, applyReason } = res.data;
          console.log(res.data);
          this.companyForm = { userName, companyCode, companyName, applyReason };
          let arr = Object.keys(res.data);
          if (arr.length == 0) {
            this.companyType = 3
          } else {
            this.companyType = res.data.approvalState;

          }
          this.rejectForm = res.data
          this.companyUserName = res.data.companyName
        } else {
          this.userName = localStorage.getItem('userName');
          this.companyType = 3
        }
        // if (arr == null) {
        //   this.companyType = 3
        // }

        // if (res.data == null) {
        //   this.companyType = 3
        // }

        // 未申请
      })
    },
    openScheduleFrom(formName) {
      this.dialogFormVisible = true;
      this.$refs[formName].resetFields();
    },
    onPanelChange(value, mode) {
      console.log(value, mode);
    },
    selectData(date) {
      this.scheduleParams.localDate = new Date(date).toLocaleString();
      this.getScheduleData();
    },
    cancelSchedule(item) {
      delScheduleById(item.id).then(res => {
        if (res.code === 0) {
          this.$message.success("取消日程成功");
          this.getScheduleData();
        } else {
          this.$message.error("取消日程失败");
        }
      })

    },
    getMonths(value) {
      const current = value.clone();
      const localeData = value.localeData();
      const months = [];
      for (let i = 0; i < 12; i++) {
        current.month(i);
        months.push(localeData.monthsShort(current));
      }
      return months;
    },
    getYears(value) {
      const year = value.year();
      const years = [];
      for (let i = year - 10; i < year + 10; i += 1) {
        years.push(i);
      }
      return years;
    },
    currentArticleChange(val) {
      this.coArticleParams.pageNum = val;
      if (this.coArticleParams.articleType !== "PT_POLICY") {
        articleList(this.coArticleParams).then(res => {
          this.articleRows = res.rows;
          this.coArticleTotal = Number(res.total);
        })
      } else {
        getConsultList(this.coArticleParams).then(res => {
          this.articleRows = res.rows;
          this.coArticleTotal = Number(res.total);
        })
      }
    },
    /**
     * 分页触发逻辑
     * @param val
     */
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      // getConsultList(this.queryParams).then(res => {
      //   this.rows = res.rows;
      //   this.total = Number(res.total);
      // })
      getConsultList(this.queryParams).then(res => {
        this.rows = res.rows.map(
          item => {
            // var publishTime = new Date(item.createTime);
            // item.day = publishTime.getDay();
            // item.month = publishTime.getMonth();
            item.day = dayjs(item.createTime).format("DD");
            item.month = dayjs(item.createTime).format("M");
            return item;
          }
        )
        this.total = Number(res.total);
      })
    },
    handleOfficeChange(val) {
      this.officeQueryParams.pageNum = val
      this.getOfficeList()
    },
    getScheduleData() {
      listSchedule(this.scheduleParams).then(res => {
        this.scheduleTotal = res.data.total;
        this.scheduleRows = res.data.rows.map(item => {
          var startTime = new Date(item.startTime).toLocaleTimeString();
          var endTime = new Date(item.endTime).toLocaleTimeString();
          item.intervalTime = startTime.substring(0, startTime.lastIndexOf(":")) + "-" + endTime.substring(0, endTime.lastIndexOf(":"));
          return item;
        })
      })
    },
    /**
     * 页面加载时数据初始化
     */
    getList() {
      //我的产品初始化
      getUserInfo().then(res => {
        console.log(res, 'ressss');
        this.myproductnum = res.data.pList.length;
        this.myteammenbernum = res.data.teamPersonNum;
        if (res.data.list) {
          this.userId = res.data.list.username || "";
          // this.userName = lres.data.list. ;
          this.comUserName = res.data.list.username || "";
          this.companyForm.userName = this.userName || "";
        }
        this.productList = res.data.pList.map(item => {
          // console.log(item.remark.split('@@'), 'item');
          const arr = String(item.remark).split('@@');
          item.url = arr[0]
          item.desc = arr[1]
          item.sysName = item.dict_label;
          return item
        })

      });

      this.scheduleParams.localDate = new Date().toLocaleString();
      this.getScheduleData();

      //最近产品初始化
      getRecord().then(res => {
        this.resentProductList = res.rows.map(
          item => {
            const arr = item.sysRemark.split('@@')
            item.url = arr[0]
            item.desc = arr[1]
            return item;
          }
        )
      });

      //通知公告,制度规范类数据初始化
      articleList(this.coArticleParams).then(res => {
        this.articleRows = res.rows;
        this.coArticleTotal = Number(res.total);
      })

      //平台资讯类数据初始化
      getConsultList(this.queryParams).then(res => {
        this.rows = res.rows.map(
          item => {
            // var publishTime = new Date(item.createTime);
            // item.day = publishTime.getDay();
            // item.month = publishTime.getMonth();
            item.day = dayjs(item.createTime).format("DD");
            item.month = dayjs(item.createTime).format("M");
            return item;
          }
        )
        this.total = Number(res.total);
      })
    },
    // 办公用品
    getOfficeList() {
      let params = {
        pageNum: this.officeQueryParams.pageNum,
        pageSize: this.officeQueryParams.pageSize,
        name: this.officeQueryParams.officeName
      }
      getOfficeList(params).then(res => {
        this.officetList = res.rows
        this.officeTotal = res.total
      })
    },
    changeProductType() {
      this.isall = !this.isall;
      if (this.isall) {
        listProduct({ "type": "A" }).then(res => {
          this.productList = res.data.map(item => {
            const arr = item.sysRemark.split('@@');
            item.url = arr[0];
            item.desc = arr[1];
            item.sysName = item.systemName;
            return item;
          })
        })
      } else {
        getUserInfo().then(res => {
          this.productList = res.data.pList.map(item => {
            const arr = String(item.remark).split('@@');
            item.url = arr[0]
            item.desc = arr[1]
            item.sysName = item.dict_label;
            return item
          })
          console.log(this.productList, 'prlist');
        });
      }
    },
    openArticle(item) {
      if (item.articleType === 'CO_RULES' || item.articleType === 'CO_NOTICE') {
        this.type = true;
      }
      this.$router.push({ path: '/ConsultDetails', query: { id: item.id, name: item.articleType, type: this.type, title: item.articleType } })
    },
    handleItemClick(item) {
      addRecord(item).then(() => {
        let windowObj
        if (item.url.indexOf('cwzx') != -1 || item.url.indexOf('scmfin') != -1 || item.url.indexOf('okr') != -1) {
          windowObj = window.open(`${item.url}?userId=${localStorage.userId}&token=${localStorage.usertoken}`)
        } else if (item.url.indexOf('app') != -1) {
          windowObj = window.open(`${item.url}?userName=${localStorage.userName}&token=${localStorage.usertoken}`)
        } else if (item.url.indexOf('ProductConsoleRJ') != -1) {
          // const url = item.url.split('//');
          // url[0] = window.location.protocol;
          windowObj = window.open(`${window.location.origin}/ProductConsoleRJ`);
        } else {
          windowObj = window.open(`${item.url}?token=${localStorage.usertoken}`)
        }
        setTimeout(() => {
          if (windowObj) {
            const username = localStorage.userName
            if (username.length !== 11) return
            windowObj.postMessage({ username, type: 'username' }, '*')
          }
        }, 3000)

        // this.getList()
      })
    },
    officeItemClick(item) {
      if(item.name === '日行一善') {
        this.$router.push('/DoOneGood/index')
      }else if(item.name === '晨会') {
        this.$router.push('/morningMeet/index')
      }else {
        window.open(item.webAddress)
      }
    },
    /**
     * 通知公告,制度规范,行业政策切换页签时数据的获取
     * @param value
     */
    changeNtab(value) {
      this.isactive = value;
      this.coArticleParams.pageNum = 1;
      switch (value) {
        case 1:
          this.coArticleParams.articleType = "CO_NOTICE";
          articleList(this.coArticleParams).then(res => {
            this.articleRows = res.rows;
            this.coArticleTotal = Number(res.total);
          });
          break;
        case 2:
          this.coArticleParams.articleType = "CO_RULES";
          articleList(this.coArticleParams).then(res => {
            this.articleRows = res.rows;
            this.coArticleTotal = Number(res.total);
          });
          break;
        case 3:
          this.coArticleParams.articleType = "PT_POLICY";
          getConsultList(this.coArticleParams).then(res => {
            this.articleRows = res.rows;
            this.coArticleTotal = Number(res.total);
          });
          break;
        default:
      }
    },
    async getNewslist() {
      await getConsultList(this.coArticleParams).then(res => {
        this.articleRows = res.rows;
        this.coArticleTotal = Number(res.total);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.erweima {
  width: 210px;
  height: 210px;

  img {
    width: 100%;
    height: 100%;
  }
}

/deep/ .el-empty {
  padding: 0;
}

p {
  line-height: 1;
}

/deep/ .ant-divider {
  margin: 10px 0;
}

/deep/.el-link--inner {
  font-size: 14px;
}

/deep/.ant-fullcalendar {
  border: none;
}

/deep/.el-row {
  width: 100%;
}

/deep/.el-button {
  &:hover {
    background-color: #ecf5ff;
    border-color: #409eff;
    color: #409eff;
  }

}

// /deep/ .el-dialog--center .el-dialog__body {
//   align-items: center;
// }

.richeng {
  li {
    display: flex;
    height: 44px;
    padding: 8px 0px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }
}

.ctbox {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 0 !important;
}

/deep/.el-button--primary {
  background-color: #409eff !important;
  border-color: #409eff !important;
  color: #fff !important;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #409EFF;
  color: #fff !important;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #409EFF;
}

/deep/.ant-fullcalendar {
  background-color: red !important;
}

.el-row {
  z-index: 1000;
}

.bg {
  width: 100%;
  height: 100%;
  background: url(../assets/images/console/bg-img.png);
  background-size: 100% 100%;
}

.container {
  width: 1280px;
  margin: 0 auto;
  position: relative;

  .cloud {
    position: absolute;
    z-index: 999;
    right: 100px;
    top: -90px;

    img {
      width: 589px;
      height: 589px;
    }
  }
}

ul {
  list-style: none;
  padding: 0;
}

.product-list {
  width: 100%;
  min-height: 239px;
  background: #ffffff;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid #e8ebf3;
}

.recent-list {
  min-height: 182px;
  background: #ffffff;
  border: 1px solid #e8ebf3;
  margin-top: 30px;
  padding: 20px;
  box-sizing: border-box;
}

.document {
  background: #ffffff;
  border: 1px solid #e8ebf3;
  height: 247px;
  margin-top: 30px;
  padding: 20px;

  ul {
    padding: 0;

    li {
      list-style: none;
      line-height: 35px;

      &:hover {
        color: #e50009;
        cursor: pointer;
      }
    }
  }
}

.h1 {
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  color: #131415;
}

.box {
  height: 75px;
  background: #ffffff;
  border: 1px solid #e8ebf3;
  margin-top: 20px;
  cursor: pointer;
  padding: 10px;
  box-sizing: border-box;

  .title {
    font-size: 16px;
    font-weight: 400;
    height: 22px;
    margin-bottom: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .desc {
    font-size: 12px;
    font-weight: 400;
    color: rgba(19, 20, 21, 0.70);
    height: 17px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover .title {
    color: #e50009;
  }
}

.combutton {
  width: 100%;
  height: 100px;
  background: url(../assets/images/console/btbg.png) !important;
  background-size: 100% 100% !important;
  text-align: left;

  &>span {
    display: inline-block;
    width: 100%;
    height: 100%;
  }

  div:first-child {
    font-size: 16px;
    color: #000;
    margin-bottom: 10px;

    span {
      font-size: 0.16rem !important;
      display: inline-block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }


  .lastuse {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;


    span {
      font-size: 12px !important;
    }
  }

}

.combutton_office {
  width: 100%;
  height: 100px;
  background: url(../assets/images/console/btbg.png) !important;
  background-size: 100% 100% !important;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;

  .com_office {
    display: flex;
    gap: 8px;
    align-items: center;

    .com_office_img {
      width: 40px;
      height: 40px;

      >img {
        width: 40px;
        height: 40px;
      }
    }

    .com_office_name {
      width: 110px;
      line-height: 20px;

      .text {
        font-size: 14px;
        overflow: hidden;
        white-space: normal;
        line-height: 20px;
        word-wrap: break-word !important;
        margin: 0;
      }
    }
  }
}

.comcol {
  margin-top: 20px;

  ul {
    li {
      margin-bottom: 20px;
      display: flex;
      align-items: center;


      .date {
        width: 45px;
        height: 44px;
        background-color: #e8ebf3;
        padding-top: 6px;
        border-radius: 2px;

        .number {
          width: 43px;
          height: 42px;
          background-color: #f2f3f5;
          margin-left: 1px;
          text-align: center;
          padding-top: 2px;

          p {
            margin: 0;
            padding: 0;
          }

          .day {
            font-size: 16px;
            // margin-top: 6px;
          }

          .mon {
            font-size: 12px;
            margin-top: 2px;
            color: #99a7ba;
          }
        }
      }

      .content {
        margin: 0;
        padding: 0;
        margin-left: 20px;
        cursor: pointer;
        font-size: 14px !important;
        position: relative;

        &:hover {
          &::after {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            height: 0;
            bottom: -5px;
            border-bottom: 1px solid #409eff;
          }
        }
      }



    }
  }
}

.comtab {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .tab {
    font-size: 16px;
    position: relative;
    cursor: pointer;
    font-weight: bold;
    display: flex;

    .left_product {
      font-size: 16px;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      display: flex;
      color: #999;
    }

    .left_product_choose {
      font-size: 16px;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      display: flex;

      &::after {
        content: "";
        width: 64px;
        height: 3px;
        display: inline-block;
        background-color: #4081ff;
        position: absolute;
        left: 0;
        bottom: -8px;
      }
    }

  }

  .left {
    font-size: 16px;
    position: relative;
    cursor: pointer;
    font-weight: bold;
    display: flex;

    &::after {
      content: "";
      width: 64px;
      height: 3px;
      display: inline-block;
      background-color: #4081ff;
      position: absolute;
      left: 0;
      bottom: -8px;
    }
  }

  .right {
    font-size: 12px;
    color: #4081ff;
    cursor: pointer;
  }
}

.box-card {
  margin-bottom: 20px;
  z-index: 1000;

  &:last-child {
    margin-bottom: 0;
  }

  &.header-card {
    background-color: #f3f6fa;

    .header {
      display: flex;

      .icon {
        margin-left: 4.16667%;
        ;
      }

      .info {
        margin-left: 20px;

        .addCompany {
          display: flex;
          align-items: center;
          gap: 10px;

          p {
            font-size: 14px;
          }

          div {
            font-size: 14px;
            // width: 80px;
            padding: 0 5px;
            box-sizing: border-box;
            height: 30px;
            background: #4081ff;
            color: #f2f3f5;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
        }

        p {
          margin: 0;
          padding: 0;
        }

        .name {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 6px;
        }

        .company {
          font-size: 14px;
          color: #999;
        }
      }
    }

    .team {
      width: 100%;
      height: 138px;
      margin-top: 20px;
      margin: 20px auto 0px;
      background: url(../assets/images/console/teamimg.png);
      background-size: 100% 100%;
      padding-top: 22px;

      .teambox {
        width: 246px;
        height: 116px;
        margin: 0 auto;
        display: flex;

        p {
          margin: 0;
          padding: 0;
          font-size: 14px;
          color: #fff;
        }

        img {
          width: 58px;
          height: 58px;
        }

        .team-title {
          // margin-bottom: 10px;
          margin-top: 12px;
          margin-bottom: 5px;
        }

        .tuandui {
          width: 50%;
          height: 100%;
          text-align: center;
        }

        .yingyong {
          width: 50%;
          height: 100%;
          text-align: center;
        }
      }
    }


  }
}

.right {
  font-size: 12px;
  color: #4081ff;
  cursor: pointer;
  text-align: right;
}

.newstab {
  display: flex;
  justify-content: space-between;
  height: 30px;
  // margin-bottom: 28px;

  .left {
    display: flex;

    >div {
      font-size: 16px;
      position: relative;
      cursor: pointer;
      font-weight: bold;
      margin-left: 10px;


    }

    &.tab {
      >div {
        font-weight: normal;
        text-align: center;
        width: 80px;

        &:first-child {
          margin-left: 0;
        }

        &.active {
          font-weight: bold;

          &::after {
            content: "";
            width: 64px;
            height: 3px;
            display: inline-block;
            background-color: #4081ff;
            position: absolute;
            left: 8px;
            bottom: 0px;
          }
        }
      }
    }
  }
}

// ::v-deep(.footerbt span) {

//   font-size: 12px !important;

// }
.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Console.vue